module.exports = __webpack_public_path__ + "img/sg_cover.b46b3458.webp";